import routeDetails from 'react/api/actions/routeDetails';
import { getTelematicPropertyFromEquipmentAndRenderTelematics } from 'react/utils/telematicsUtils';

Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.MultiRouteController = function () {
  this.generatePathForEquipmentsInInterval = function (
    route,
    equipmentsList,
    beginDate,
    endDate,
    callbackAfterGetCoordinates
  ) {
    const screen = Monet.Session.RouteDetail.screensList[route.id];
    const principalEquipment = screen.equipment;

    const secondaryEquipments = equipmentsList.filter(equipment => 
      !principalEquipment.idOfObject || 
      equipment.id.toString() !== principalEquipment.idOfObject.toString()
    ).sort((a, b) => parseInt(a.id) - parseInt(b.id));

    screen.equipmentColorMapping = {};
    secondaryEquipments.forEach((equipment, index) => {
      const colorIndex = index % screen.routeColor.length;
      screen.equipmentColorMapping[equipment.id] = colorIndex;
    });

    new Greenmile.RouteDetail.InfoRoute(
      Monet.Session.RouteDetail.screensList[route.id].map,
      route.id
    ).removeActualRoute();

    if (principalEquipment.idOfObject) {
      screen.equipments = screen.equipments || {};
      screen.equipments[principalEquipment.idOfObject] = {
        id: principalEquipment.idOfObject,
        key: principalEquipment.key,
        coordinates: screen.coordinates
      };

      const principalEquipmentExists = equipmentsList.some(
        (equip) => equip.id === principalEquipment.idOfObject
      );

      if (!principalEquipmentExists) {
        equipmentsList.push(screen.equipments[principalEquipment.idOfObject]);
      }
    }

    if (equipmentsList.length) {
      for (const equipment of equipmentsList) {
        this.pathForEquipmentInInterval(
          route,
          equipment,
          beginDate,
          endDate,
          callbackAfterGetCoordinates
        );
      }
    }

  };

  this.pathForEquipmentInInterval = function (
    route,
    equipment,
    beginDate,
    endDate,
    callbackAfterRequest
  ) {
    const callback = (_, positionSources) => {
      const layers = GreenmileReduxStore.getState().routeDetails.toJS().activeLayers;
      const screen = Monet.Session.RouteDetail.screensList[route.id];
      screen.positionSources = positionSources;

      const renderTelematics = () => {
        const telematicContainer = document.querySelector(
          `#routeMaps_${route.id} #routeDetailTelematic`
        );
        if (
          telematicContainer.getAttribute('aria-hidden') === 'false'
        ) {
          getTelematicPropertyFromEquipmentAndRenderTelematics(
            equipment.id,
            positionSources,
            telematicContainer,
            screen,
            false
          );
        }
      };

      const updateToolbarLayer = () => {
        if (!positionSources?.size()) return;
        window.GreenmileReduxStore.dispatch(routeDetails.actionCreators.updateToolbarLayers(route.id, positionSources));        
      };

      const isEquipmentAssignedAndIsPrincipal = (route.equipmentAssignments?.filter(
        (equipmentAssigned) =>
          equipmentAssigned?.equipment?.id.toString() ===
          equipment.id.toString() && equipmentAssigned?.principal === true
      ) || []).length > 0;

      const actualPathLayerRoute = JSON.parse(
        Monet.Session.sessionStorage.getItem('layerMap')
      ).actual_route;

      if (actualPathLayerRoute) { 
        Greenmile.RouteDetail.Util.renderPathFromPositionSources(
          equipment,
          route,
          positionSources,
          layers?.[route.id]
        );
      }

      if (isEquipmentAssignedAndIsPrincipal) {
        updateToolbarLayer();
        renderTelematics();
      }

      if (callbackAfterRequest) {
        callbackAfterRequest(equipment);
      }

    }

    new Greenmile.Coordinates.GeneralFunctions(
      Monet.Session.RouteDetail.screensList[route.id]
    ).requestCoordinateByEquipment(equipment.id, beginDate, endDate, callback);
  };

  this.drawCaptions = function (route) {
    const equipmentsWithCoordinates = [];
    const equipments = Monet.Session.RouteDetail.screensList[route.id].equipments;

    for (let equip in equipments) {
      let equipment =
        Monet.Session.RouteDetail.screensList[route.id].equipments[equip];
      equipmentsWithCoordinates.push(equipment);
    }

    Greenmile.RouteDetail.Util.renderCaptions(route.id, equipmentsWithCoordinates);
  };
};
